import NotificationsPermission from "./NotificationsPermission";
export default NotificationsPermission;
